import React, { Component } from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

class Income extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msgData: {
        errors: {},
        info: {},
      },
    };

    this.state.msgData.errors[props.incomeType] = {};
    this.state.msgData.info[props.incomeType] = {};
    this.incomeMaxLength = 10;
    this.maxAmount = 9999999;
  }

  static defaultProps = {
    element: {
      name: "income",
      label: "Total Annual Income",
      placeHolder: "$ Per Year",
      usDollar: "$",
      colLabelClassName: "label",
      colFieldClassName: "field",
      colValidationClassName: "messaging",
    },
    prefix: "pf-exp-inc-",
    id: "pf-exp-inc-salary",
    incomeType: "salary",
    zeroIncomes: false,
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 3 },
      3: { sm: 12, lg: 6 },
    },
  };

  initMsgObj = () => {
    const { incomeType } = this.props,
      msgData = {
        errors: {},
      };

    msgData.errors[incomeType] = {};

    return msgData;
  };

  generateMessage = (zeroIncomes = false) => {
    const { incomeType, id } = this.props,
      msgData = this.initMsgObj();

    let msg = "";

    if (zeroIncomes) {
      msg = "Total Annual Income cannot be zero.";
    } else {
      msg = "Total Annual Income is required.";
    }

    msgData.errors[incomeType] = {
      type: "error",
      msg: msg,
      id: id,
      slug: incomeType,
    };

    return msgData;
  };

  isValueAllowed = (valueObj) => {
    return !valueObj.value || valueObj.floatValue <= this.maxAmount;
  };

  handleValueChange = (valueObj, ev) => {
    // valueObj => {formattedValue: "$x,xxx.xx", value: "xxxx.xx", floatValue: xxxx.xx}
    const { fieldMetadata } = this.props;
    fieldMetadata.value = valueObj.value;
  };

  handleBlur = (ev) => {
    const { onEventCallback, fieldMetadata } = this.props;
    let msgData = this.initMsgObj();

    if (fieldMetadata.value.length === 0 && fieldMetadata.isRequired) {
      msgData = this.generateMessage();
      fieldMetadata.status = "invalid";
      fieldMetadata.isValid = false;
    } else {
      fieldMetadata.status = "";
      fieldMetadata.isValid = true;
    }

    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, fieldMetadata);
    }

    this.setState({ msgData });
  };

  render() {
    const { colLayout, element, incomeType, id, fieldMetadata, zeroIncomes } =
        this.props,
      rowClass = `${id} overflow-visible`,
      inputName = "income";

    let { msgData } = this.state;

    if (zeroIncomes) {
      msgData = this.generateMessage(zeroIncomes);
    } else if (fieldMetadata.status === "invalid") {
      msgData = this.generateMessage();
    }

    return (
      <Row className={rowClass}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label className="label-split" htmlFor={id}>
            <span className="text">{element.label}</span>
          </label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <NumberFormat
            key={fieldMetadata.value}
            id={id}
            name={inputName}
            className={fieldMetadata.status}
            type="tel"
            decimalScale={0}
            maxLength={this.incomeMaxLength}
            prefix={element.usDollar}
            isNumericString={true}
            allowNegative={false}
            thousandSeparator={true}
            placeholder={element.placeHolder}
            onBlur={this.handleBlur}
            onValueChange={this.handleValueChange}
            defaultValue={fieldMetadata.value}
            autoComplete={fieldMetadata.autocomplete || null}
            isAllowed={this.isValueAllowed}
          />
        </Col>
        <Col className={element.colValidationClassName} width={colLayout[3]}>
          <ValidationMsg
            who={incomeType}
            filterFields={[incomeType]}
            msgs={msgData}
          />
        </Col>
      </Row>
    );
  }
}

Income.propTypes = {
  colLayout: PropTypes.object.isRequired,
  element: PropTypes.object,
  onEventCallback: PropTypes.func,
  fieldMetadata: PropTypes.object.isRequired,
  incomeType: PropTypes.string,
  id: PropTypes.string,
  prefix: PropTypes.string,
  zeroIncomes: PropTypes.bool,
  defaultValue: PropTypes.string,
};

export default Income;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');